import { render } from "./ApprovalVideoModal.vue?vue&type=template&id=deb2ee80&scoped=true"
import script from "./ApprovalVideoModal.vue?vue&type=script&lang=js"
export * from "./ApprovalVideoModal.vue?vue&type=script&lang=js"

import "./ApprovalVideoModal.vue?vue&type=style&index=0&id=deb2ee80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deb2ee80"]])

export default __exports__